export default __webpack_public_path__ + "media/dropdown-icon-down-white.d9337920.svg";